import {capitalize} from 'lodash-es';

import type {ConfirmationLabelTypeProps} from './types';
import {WALLET_TYPE_LABELS} from './useFundBusinessWallet';

const ConfirmationLabel = ({
  action,
  amount,
  currency,
  business,
  fundWalletReason,
  walletType,
}: ConfirmationLabelTypeProps) => (
  <div className="flex flex-col gap-3">
    <h3>
      Are you sure you want to {action} &nbsp;
      <span className="text-indigo-500 text-center">
        {amount} {currency?.code}
      </span>{' '}
      {action === 'credit' ? 'to ' : 'from '} {business.name}?
    </h3>
    <p className="text-sm font-medium">
      Wallet Type:{' '}
      <span
        className={`font-regular ${
          action === 'credit' ? 'text-successful-500' : 'text-failed-500'
        }`}
      >
        {WALLET_TYPE_LABELS[walletType]}
      </span>
    </p>
    <p className="text-sm font-medium">
      Reason:{' '}
      <span
        className={`font-regular ${
          action === 'credit' ? 'text-successful-500' : 'text-failed-500'
        }`}
      >
        {capitalize(fundWalletReason?.replace(/_/g, ' '))}
      </span>
    </p>
    <div className="text-sm font-light mt-3">
      Double check the amount before clicking confirm
    </div>
  </div>
);

export default ConfirmationLabel;
